import { combineReducers } from 'redux'
import abuseReducer, { initialState as abuseInitialState } from 'services/abuse/reducers'
import adyenReducer, { initialState as adyenInitialState } from 'services/adyen/reducers'
import alertBarReducer, { initialState as alertBarInitialState } from 'services/alert-bar/reducers'
import appReducer, { initialState as appInitialState } from 'services/app/reducers'
import ambassadorsReducer, { initialState as ambassadorsInitialState } from 'services/ambassadors/reducers'
import assetsReducer, { initialState as assetsInitialState } from 'services/assets/reducers'
import authReducer, { initialState as authInitialState } from 'services/auth/reducers'
import checkoutReducer, { initialState as checkoutInitialState } from 'services/checkout/reducers'
import commentsReducer, { initialState as commentsInitialState } from 'services/comments/reducers'
import communityProfileReducer, { initialState as communityProfileInitialState } from 'services/community/identity/profile/redux/reducers'
import complianceManagementReducer, { initialState as complianceManagementInitialState } from 'services/compliance-management/reducers'
import continueWatchingReducer, { initialState as continueWatchingInitialState } from 'services/continue-watching/reducers'
import cookieReducer, { initialState as cookieInitialState } from 'services/cookie/reducers'
import dialogReducer, { initialState as dialogInitialState } from 'services/dialog/reducers'
import emailSignupReducer, { initialState as emailSignupState } from 'services/email-signup/reducers'
import eventTrackingReducer, { initialState as eventTrackingState } from 'services/event-tracking/reducers'
import externalAppReducer, { initialState as externalAppInitialState } from 'services/external-app/reducers'
import featureTrackingReducer, { initialState as featureTrackingState } from 'services/feature-tracking/reducers'
import filterSetReducer, { initialState as filterSetInitialState } from 'services/filter-set/reducers'
import formSubmissionsReducer, { initialState as formSubmissionsInitialState } from 'services/form-submissions/reducers'
import giftReducer, { initialState as giftInitialState } from 'services/gift/reducers'
import guidesReducer, { initialState as guidesInitialState } from 'services/guides/reducers'
import guideDaysReducer, { initialState as guideDaysInitialState } from 'services/guide-days/reducers'
import headerReducer, { initialState as headerInitialState } from 'components/Header/reducers'
import hideWatchedReducer, { initialState as hideWatchedInitialState } from 'services/hide-watched/reducers'
import hiddenContentPreferencesReducer, { initialState as hiddenContentPreferencesInitialState } from 'services/hidden-content-preferences/reducers'
import inboundTrackingReducer, { initialState as inboundTrackingState } from 'services/inbound-tracking/reducers'
import interstitialReducer, { initialState as interstitialState } from 'services/interstitial/reducers'
import jumbotronReducer, { initialState as jumbotronInitialState } from 'services/jumbotron/reducers'
import languagesReducer, { initialState as languagesInitialState } from 'services/languages/reducers'
import liveAccessEventsReducer, { initialState as liveAccessEventsInitialState } from 'services/live-access-events/reducers'
import loginReducer, { initialState as loginInitialState } from 'components/Login/reducers'
import mediaReducer, { initialState as mediaInitialState } from 'services/media/reducers'
import menuReducer, { initialState as menuInitialState } from 'services/menu/reducers'
import messageBoxReducer, { initialState as messageBoxInitialState } from 'components/MessageBox/reducers'
import { nodeReducer, initialState as nodeInitialState } from 'services/node/reducers'
import notificationsReducer, { initialState as notificationsInitialState } from 'services/notifications/reducers'
import oracleReducer, { initialState as oracleInitialState } from 'services/oracle/reducers'
import onboardingReducer, { initialState as onboardingInitialState } from 'services/onboarding/reducers'
import optimizelyReducer, { initialState as optimizelyInitialState } from 'services/optimizely/reducers'
import optimizelyFeatureReducer, { initialState as optimizelyFeatureInitialState } from 'services/optimizely-feature/reducers'
import pageReducer, { initialState as pageInitialState } from 'services/page/reducers'
import paymentReducer, { initialState as paymentInitialState } from 'services/payment/reducers'
import paytrackReducer, { initialState as paytrackInitialState } from 'services/paytrack/reducers'
import plansReducer, { initialState as plansInitialState } from 'services/plans/reducers'
import playlistReducer, { initialState as playlistInitialState } from 'services/playlist/reducers'
import pmScreenReducer, { initialState as pmScreenInitialState } from 'services/pm-screen/reducers'
import pmSectionReducer, { initialState as pmSectionInitialState } from 'services/pm-section/reducers'
import pmListReducer, { initialState as pmListInitialState } from 'services/pm-list/reducers'
import popupMarketingPromoReducer, { initialState as popupMarketingPromoState } from 'components/PopupMarketingPromo/reducers'
import portalReducer, { initialState as portalInitialState } from 'services/portal/reducers'
import recentlyAddedReducer, { initialState as recentlyAddedState } from 'services/recently-added/reducers'
import referralReducer, { initialState as referralInitialState } from 'services/referral/reducers'
import remoteLoginCodeReducer, { initialState as remoteLoginCodeInitialState } from 'services/remote-login-code/reducers'
import resetPasswordReducer, { initialState as resetPasswordInitialState } from 'services/reset-password/reducers'
import resolverReducer, { initialState as resolverInitialState } from 'services/resolver/reducers'
import searchReducer, { initialState as searchInitialState } from 'services/search/reducers'
import serverTimeReducer, { initialState as serverTimeInitialState } from 'services/server-time/reducers'
import shareReducer, { initialState as shareState } from 'services/share/reducers'
import staticTextReducer, { initialState as staticTextInitialState } from 'services/static-text/reducers'
import subscriptionReducer, { initialState as subscriptionInitialState } from 'services/subscription/reducers'
import testarossaReducer, { initialState as testarossaInitialState } from 'services/testarossa/reducers'
import tilesReducer, { initialState as tilesInitialState } from 'services/tiles/reducers'
import toastyReducer, { initialState as toastyInitialState } from 'services/toasty/reducers'
import toolTipReducer, { initialState as toolTipInitialState } from 'services/tool-tip/reducers'
import tourReducer, { initialState as tourInitialState } from 'services/tour/reducers'
import updatePaymentReducer, { initialState as updatePaymentInitialState } from 'services/update-payment/reducers'
import upstreamContextReducer, { initialState as upstreamContextInitialState } from 'services/upstream-context/reducers'
import userAccountReducer, { initialState as userAccountInitialState } from 'services/user-account/reducers'
import userNodeInfoReducer, { initialState as userNodeInfoInitialState } from 'services/user-node-info/reducers'
import userProfilesReducer, { initialState as userProfilesInitialState } from 'services/user-profiles/reducers'
import userReducer, { initialState as userInitialState } from 'services/user/reducers'
import userVideoReducer, { initialState as userVideoInitialState } from 'services/user-video/reducers'
import velocityCheckReducer, { initialState as velocityCheckInitialState } from 'services/velocity-check/reducers'
import videoPlayerReducer, { initialState as videoPlayerInitialState } from 'components/VideoPlayer/reducers'
import videoReducer, { initialState as videoInitialState } from 'services/video/reducers'

// alphabetical order matters new redux devtools
// please list new reducers in order
export const reducers = {
  abuse: abuseReducer,
  adyen: adyenReducer,
  alertBar: alertBarReducer,
  ambassadors: ambassadorsReducer,
  app: appReducer,
  assets: assetsReducer,
  auth: authReducer,
  checkout: checkoutReducer,
  comments: commentsReducer,
  communityProfile: communityProfileReducer,
  complianceManagement: complianceManagementReducer,
  continueWatching: continueWatchingReducer,
  cookie: cookieReducer,
  dialog: dialogReducer,
  emailSignup: emailSignupReducer,
  eventTracking: eventTrackingReducer,
  externalApp: externalAppReducer,
  featureTracking: featureTrackingReducer,
  filterSet: filterSetReducer,
  formSubmissions: formSubmissionsReducer,
  gift: giftReducer,
  guides: guidesReducer,
  guideDays: guideDaysReducer,
  header: headerReducer,
  hideWatched: hideWatchedReducer,
  hiddenContentPreferences: hiddenContentPreferencesReducer,
  inboundTracking: inboundTrackingReducer,
  interstitial: interstitialReducer,
  jumbotron: jumbotronReducer,
  languages: languagesReducer,
  liveAccessEvents: liveAccessEventsReducer,
  login: loginReducer,
  media: mediaReducer,
  menu: menuReducer,
  messageBox: messageBoxReducer,
  node: nodeReducer,
  notifications: notificationsReducer,
  oracle: oracleReducer,
  onboarding: onboardingReducer,
  optimizely: optimizelyReducer,
  optimizelyFeature: optimizelyFeatureReducer,
  page: pageReducer,
  payment: paymentReducer,
  paytrack: paytrackReducer,
  plans: plansReducer,
  playlist: playlistReducer,
  pmScreen: pmScreenReducer,
  pmSection: pmSectionReducer,
  pmList: pmListReducer,
  popupMarketingPromo: popupMarketingPromoReducer,
  portal: portalReducer,
  recentlyAdded: recentlyAddedReducer,
  remoteLoginCode: remoteLoginCodeReducer,
  resetPassword: resetPasswordReducer,
  resolver: resolverReducer,
  search: searchReducer,
  serverTime: serverTimeReducer,
  share: shareReducer,
  staticText: staticTextReducer,
  subscription: subscriptionReducer,
  testarossa: testarossaReducer,
  tiles: tilesReducer,
  toasty: toastyReducer,
  toolTip: toolTipReducer,
  tour: tourReducer,
  updatePayment: updatePaymentReducer,
  upstreamContext: upstreamContextReducer,
  user: userReducer,
  userAccount: userAccountReducer,
  userNodeInfo: userNodeInfoReducer,
  userProfiles: userProfilesReducer,
  userReferrals: referralReducer,
  userVideo: userVideoReducer,
  velocityCheck: velocityCheckReducer,
  video: videoReducer,
  videoPlayer: videoPlayerReducer,
}

// alphabetical order matters with redux devtools
// please list new reducers in order
export const initialState = {
  abuse: abuseInitialState,
  adyen: adyenInitialState,
  alertBar: alertBarInitialState,
  ambassadors: ambassadorsInitialState,
  app: appInitialState,
  assets: assetsInitialState,
  auth: authInitialState,
  checkout: checkoutInitialState,
  comments: commentsInitialState,
  communityProfile: communityProfileInitialState,
  complianceManagement: complianceManagementInitialState,
  continueWatching: continueWatchingInitialState,
  cookie: cookieInitialState,
  dialog: dialogInitialState,
  emailSignup: emailSignupState,
  eventTracking: eventTrackingState,
  externalApp: externalAppInitialState,
  featureTracking: featureTrackingState,
  filterSet: filterSetInitialState,
  formSubmissions: formSubmissionsInitialState,
  gift: giftInitialState,
  guides: guidesInitialState,
  guideDays: guideDaysInitialState,
  header: headerInitialState,
  hideWatched: hideWatchedInitialState,
  hiddenContentPreferences: hiddenContentPreferencesInitialState,
  inboundTracking: inboundTrackingState,
  interstitial: interstitialState,
  jumbotron: jumbotronInitialState,
  languages: languagesInitialState,
  liveAccessEvents: liveAccessEventsInitialState,
  login: loginInitialState,
  media: mediaInitialState,
  menu: menuInitialState,
  messageBox: messageBoxInitialState,
  node: nodeInitialState,
  notifications: notificationsInitialState,
  oracle: oracleInitialState,
  onboarding: onboardingInitialState,
  optimizely: optimizelyInitialState,
  optimizelyFeature: optimizelyFeatureInitialState,
  page: pageInitialState,
  payment: paymentInitialState,
  paytrack: paytrackInitialState,
  plans: plansInitialState,
  playlist: playlistInitialState,
  pmScreen: pmScreenInitialState,
  pmSection: pmSectionInitialState,
  pmList: pmListInitialState,
  popupMarketingPromo: popupMarketingPromoState,
  portal: portalInitialState,
  recentlyAdded: recentlyAddedState,
  remoteLoginCode: remoteLoginCodeInitialState,
  resetPassword: resetPasswordInitialState,
  resolver: resolverInitialState,
  search: searchInitialState,
  serverTime: serverTimeInitialState,
  share: shareState,
  staticText: staticTextInitialState,
  subscription: subscriptionInitialState,
  testarossa: testarossaInitialState,
  tiles: tilesInitialState,
  toasty: toastyInitialState,
  toolTip: toolTipInitialState,
  tour: tourInitialState,
  updatePayment: updatePaymentInitialState,
  upstreamContext: upstreamContextInitialState,
  user: userInitialState,
  userAccount: userAccountInitialState,
  userNodeInfo: userNodeInfoInitialState,
  userProfiles: userProfilesInitialState,
  userReferrals: referralInitialState,
  userVideo: userVideoInitialState,
  velocityCheck: velocityCheckInitialState,
  video: videoInitialState,
  videoPlayer: videoPlayerInitialState,
}

export default combineReducers(reducers)
